import React from 'react';
import {observer} from 'mobx-react';
import ModalBase from "./ModalBase";
import axios from "axios";
import {Button, Form, FormControl, Modal} from "react-bootstrap";
import {makeObservable, observable} from "mobx";
import {MdClear} from "react-icons/md";
import notificationStore, {NOTIFICATION_TYPE} from "../../store/NotificationStore";


class MediaCutStore {

    constructor() {
        makeObservable(this);
    }

    @observable
    isOpen = false;

    @observable
    media = null;

    callback

    @observable
    start = '00:00:00';

    @observable
    end = '00:00:00';

    open = (media, callback) => {
        this.isOpen = true;
        this.start = '00:00:00';
        this.end = '00:00:00';
        this.media = media;
        this.callback = callback;
    }

    close = () => {
        this.callback = undefined;
        this.media = undefined;
        this.isOpen = false;
    }

}

const mediaCutStore = new MediaCutStore();

@observer
class MediaCutModal extends React.Component {

    render() {
        let store = mediaCutStore;
        return (
            <ModalBase
                style={{zIndex: '99999'}}
                centered
                show={store.isOpen}
                onHide={store.close}
                size={'sm'}
            >
                <Modal.Header>
                    <div className={`d-flex justify-content-between align-items-center w-100`}>
                        <Modal.Title>영상 자르기</Modal.Title>
                        <Button variant={"outline-light"} size={'sm'}
                                onClick={() => {
                                    store.close()
                                }}
                        >
                            <MdClear size={`1rem`}/>
                        </Button>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div style={{color: '#fff'}}>
                        {
                            `${store.media?.name} 자르시겠습니까?`
                        }
                    </div>
                    <div className={'d-flex flex-column gap-2'}>
                        <FormControl value={store.start} onChange={e=>{store.start = e.target.value}}/>
                        <FormControl value={store.end} onChange={e=>{store.end = e.target.value}}/>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className={`d-flex justify-content-between align-items-center w-100`}>
                        <div>

                        </div>
                        <Button variant="outline-danger"
                                onClick={() => {
                                    axios.post(
                                        `/media/cut`,
                                        {
                                            media: store.media,
                                            start: store.start,
                                            end  : store.end,
                                        }
                                    ).then(res => {
                                        notificationStore.notification("자르기가 추가 되었습니다.", '성공', NOTIFICATION_TYPE.SUCCESS)
                                        store.callback && store.callback();
                                        store.close();
                                    })
                                }}
                        >
                            자르기
                        </Button>
                    </div>
                </Modal.Footer>
            </ModalBase>
        );
    }
}

export {MediaCutModal, mediaCutStore};
